import React from "react";
import "./TermCondition.css";

const TermCondition = () => {
  return (
    <section className="yterms-policy">
      <div className="yterms-container">
        <h1 className="yterms-title">Terms & Conditions – Muktinath Darshan</h1>

        <p className="yterms-intro">
          Welcome to Muktinath Darshan. These Terms & Conditions govern the
          use of our website, services, and pilgrimage tour packages.
          By booking or accessing our website, you agree to comply with the
          following terms.
        </p>

        <div className="yterms-content">

          <p>
            <strong>Muktinath Darshan Office Address:</strong><br/>
            Bijeshwori Marg, Kathmandu, Nepal – 44600
          </p>

          <div className="yterms-full-text">

            <h3>1. Booking & Acceptance</h3>
            <p>
              By booking any Muktinath Darshan tour package, you confirm that
              all information provided is correct. Bookings are confirmed only
              after receipt of advance payment or full payment as per the
              selected package.
            </p>

            <h3>2. Travel Documents</h3>
            <p>
              Travelers are responsible for carrying valid government ID,
              passport (if required), permits, and any travel documents needed
              for Nepal travel. Muktinath Darshan will assist but is not liable
              for document-related issues.
            </p>

            <h3>3. Health & Fitness</h3>
            <p>
              Muktinath Temple is located at high altitude (approx. 3,800 meters).
              Pilgrims must ensure they are medically fit for travel. We recommend
              consulting a doctor before undertaking the pilgrimage.
            </p>

            <h3>4. Payments Policy</h3>
            <ul>
              <li>Advance payment is required to confirm booking.</li>
              <li>Remaining balance must be cleared before tour departure.</li>
              <li>Prices may change due to fuel cost, taxes, or government policies.</li>
            </ul>

            <h3>5. Cancellation & Refund Policy</h3>
            <p>
              Cancellation charges depend on the time of cancellation:
            </p>
            <ul>
              <li>30 days before travel – Minimal cancellation charges.</li>
              <li>15–30 days – Partial refund applicable.</li>
              <li>Less than 15 days – Non-refundable.</li>
              <li>Flight/Helicopter tickets follow airline policies.</li>
            </ul>

            <h3>6. Weather & Force Majeure</h3>
            <p>
              Himalayan weather conditions may cause delays or itinerary changes.
              Muktinath Darshan shall not be responsible for cancellations due to
              natural disasters, political issues, flight delays, or weather
              conditions beyond our control.
            </p>

            <h3>7. Accommodation & Transportation</h3>
            <p>
              Hotels, vehicles, and helicopters are arranged through trusted
              partners. In case of unavailability, similar category services
              will be provided without prior notice.
            </p>

            <h3>8. Responsibilities of Travelers</h3>
            <ul>
              <li>Follow local rules and religious customs.</li>
              <li>Respect temple regulations.</li>
              <li>Maintain discipline during the pilgrimage.</li>
              <li>Carry personal medicines and essentials.</li>
            </ul>

            <h3>9. Intellectual Property</h3>
            <p>
              All website content including images, itineraries, logos,
              and text belong to Muktinath Darshan and may not be copied,
              reproduced, or distributed without permission.
            </p>

            <h3>10. Cookies Policy</h3>
            <p>
              Our website uses cookies to enhance user experience,
              analyze traffic, and improve services. By using our
              website, you consent to cookie usage.
            </p>

            <h3>11. Limitation of Liability</h3>
            <p>
              Muktinath Darshan acts only as a tour organizer and shall not
              be liable for injuries, accidents, loss of baggage, delays,
              or unforeseen events occurring during travel.
            </p>

            <h3>12. Governing Law</h3>
            <p>
              These terms shall be governed under applicable laws of Nepal
              and India depending on booking origin.
            </p>

            <h3>Contact Information</h3>
            <p>
              For questions regarding Terms & Conditions, please contact:<br/>
              Email: <a href="mailto:info@muktinathdarshan.com">
              info@muktinathdarshan.com
              </a>
            </p>

          </div>
        </div>
      </div>
    </section>
  );
};

export default TermCondition;